<template>
  <form v-on:submit.prevent="submit">
    <h1 v-if="id" class="title">Edit Restaurant</h1>
    <div class="field">
      <label class="radio">
        <input type="radio" value="private" v-model="form.access">
        {{$t('private')}}
      </label>
      <label class="radio">
        <input type="radio" value="public" v-model="form.access">
        {{$t('public')}}
      </label>
    </div>
    <div class="field">
      <label class="label">Name</label>
      <div class="control">
        <input v-model="form.name" ref="name" class="input" type="text">
      </div>
    </div>
    <div class="field">
      <label class="label">Link</label>
      <div class="control">
        <input v-model="form.link" ref="link" class="input" type="url">
      </div>
    </div>
    <div class="field">
      <label class="label">Description</label>
      <div class="control">
        <textarea v-model="form.description" ref="description" class="textarea">
        </textarea>
      </div>
    </div>

    <new-categories :available="categoryNames" v-model="form.categories"></new-categories>

    <div class="field">
      <label class="label">Address</label>
      <div class="control">
        <input v-model="form.address.street" class="input" type="text" placeholder="Street">
      </div>
    </div>

    <div class="field">
      <div class="columns">
        <div class="column is-half">
          <input v-model="form.address.city" class="input" type="text" placeholder="City">
        </div>
        <div class="column">
          <input v-model="form.address.state" class="input" type="text" placeholder="State">
        </div>
        <div class="column">
          <input v-model="form.address.country" class="input" type="text" placeholder="Country">
        </div>
      </div>
    </div>

    <div class="field is-grouped is-grouped-centered">
      <p class="control">
        <button type="submit" class="button is-primary">
          Submit
        </button>
      </p>
      <p class="control">
        <a class="button is-warning" @click="confirmReset">
          Reset
        </a>
      </p>
      <p class="control">
        <a class="button is-light" @click="goBack">
          Back
        </a>
      </p>
    </div>  
  </form>
</template>

<i18n src="../../i18n/access.i18n.json"></i18n>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import routingMixin from '@/mixins/routing';
import i18nMixin from '@/mixins/i18n';
import NewCategories from '../NewCategories';

// TODO these are in RecipeForm too
function copyString(src, defValue = '') {
  return src ? src.slice() : defValue;
}

function copyArray(src, defValue = []) {
  // shallow
  return src ? src.slice() : defValue;
}

class FormData {
  constructor(o = {}) {
    this.name = copyString(o.name);
    this.link = copyString(o.link);
    this.description = copyString(o.description);
    this.categories = copyArray(o.categories);
    this.access = copyString(o.access, 'private');
    this.address = {
      street: copyString(_.get(o, 'address.street')),
      city: copyString(_.get(o, 'address.city')),
      state: copyString(_.get(o, 'address.state')),
      country: copyString(_.get(o, 'address.country')),
    };
  }
}

export default {
  name: 'restaurant-form',
  mixins: [routingMixin, i18nMixin],
  props: {
    id: {
      // Edit mode if this is set
      type: String,
      required: false,
    },
  },
  data() {
    return {
      form: new FormData(),
    };
  },
  mounted() {
    this.$nextTick(() => this.resetForm());
  },
  methods: {
    submit() {
      // TODO add validation!
      // TODO add validation!

      if (this.id) {
        this.$store.dispatch('restaurant/updateRestaurant', { id: this.id, restaurant: this.form }).then((returnedRestaurant) => {
          this.routeFoodItem({ type: 'Restaurant', id: returnedRestaurant.id, noBack: true });
        })
        .catch(err => this.$emit('flash', err.message));
      } else {
        this.$store.dispatch('restaurant/saveRestaurant', this.form).then((id) => {
          this.routeFoodItem({ type: 'Restaurant', id, noBack: true });
        })
        .catch(err => this.$emit('flash', err.message));
      }
    },
    confirmReset() {
      const self = this;
      this.$dialog.confirm({
        title: 'Reset Form',
        message: 'Are you sure?',
        confirmText: 'Reset',
        type: 'is-danger',
        hasIcon: true,
        onConfirm() {
          self.resetForm();
        },
      });
    },
    resetForm() {
      const self = this;
      let promise;
      if (this.id) {
        const loading = this.$loading.open();
        promise = this.$store.dispatch('restaurant/fetchRestaurant', this.id)
        .then(() => {
          // restaurant is frozen, because it's in the graphql store
          self.form = new FormData(self.restaurant);
          loading.close();
        })
        .catch((err) => {
          self.error = err.message;
        });
      } else {
        this.form = new FormData();
        promise = Promise.resolve();
      }

      return promise.then(() => self.$refs.name.focus());
    },
  },
  computed: {
    ...mapGetters(['categoryNames']),
    ...mapGetters('restaurant', ['restaurant']),
  },
  components: {
    NewCategories,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/restaurant/RestaurantForm.vue